import { memo } from "react";
import PropTypes from "prop-types";
import { badgeShape } from "app/utils/propTypes";
import ColoredProductBadge from "app/pages/.shared/ColoredProductBadge/ColoredProductBadge";
import { BADGE_CODES } from "app/constants";
import FavoriteBadge from "app/pages/.shared/FavoriteBadge/FavoriteBadge";
import "./BadgeList.scss";

const BadgeList = ({ badges = [], isProductPage = false }) => {
	const containsValidBadge = badges.some(badge => badge.label);

	return (
		containsValidBadge && (
			<div className="badge-list" data-testid="badge-list">
				{badges.map(badge => {
					const isFavorite = badge?.code === BADGE_CODES.COUP_DE_COEUR;
					const { txtColor, bgColor, borderColor, pictoUrl, label } = badge;
					const isColorDefined = badge.txtColor || badge.bgColor || badge.borderColor;
					const colorStyle = isColorDefined && {
						txtColor,
						bgColor,
						borderColor,
					};

					return (
						<div key={badge.label} className="badge-list__item">
							{isFavorite ? (
								<FavoriteBadge colored={isProductPage} />
							) : (
								<ColoredProductBadge
									pictoUrl={pictoUrl}
									label={label}
									colorStyle={colorStyle}
								/>
							)}
						</div>
					);
				})}
			</div>
		)
	);
};

BadgeList.propTypes = {
	badges: PropTypes.arrayOf(badgeShape),
	isProductPage: PropTypes.bool,
};

export default memo(BadgeList);
